<template>
    <div>
        <div class="tw-flex tw-flex-col tw-text-xl md:tw-flex-row tw-px-0 md:tw-pl-6 tw-pt-6 tw-pb-12 tw-border-0 md:tw-border-t md:tw-border-dark-grey">
            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/6 tw-border-b tw-border-dark-grey md:tw-border-0">
                <div class="h7 pb-2">INFORMATION</div>
            </div>

            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-5/6 tw-border-b tw-border-dark-grey md:tw-border-0">
                <div class="tw-flex tw-flex-col tw-w-full tw-font-light tw-pb-5">
                    <div class="tw-text-4xl tw-uppercase tw-pt-3 md:tw-pt-0 tw-pb-1 mb-4">Wallet Card</div>
                    <p class="description">For quick access to contact information: <a
                        class="link"
                        href="/storage/resources/wallet-card.pdf"
                        target="_blank"
                    >Download here</a></p>
                </div>

                <div class="tw-flex tw-flex-col tw-w-full tw-font-light tw-pb-5 tw-border-t tw-border-dark-grey">
                    <div class="tw-text-4xl tw-uppercase tw-pt-3 tw-pb-1 mb-4">Maps</div>
                    <div
                        v-for="(map, index) in maps"
                        :key="index"
                    >
                        <div>{{ map.name }} : <a class="ml-2 link" target="_blank" :href="'/storage/resources/maps/' + map.file_name">Download</a></div>
                    </div>
                </div>

                <div class="tw-flex tw-flex-col tw-w-full tw-font-light tw-pb-5 tw-pr-3 tw-border-t tw-border-dark-grey">
                    <div class="tw-text-4xl tw-uppercase tw-pt-3 tw-pb-1 mb-4">Links</div>

                    <v-row justify="center">
                        <v-expansion-panels
                            accordion
                            flat
                        >
                            <v-expansion-panel
                                v-for="(items, category) in links_by_category"
                                :key="category"
                            >
                                <v-expansion-panel-header hide-actions>

                                    <template v-slot:default="{ open }">

                                        <div class="tw-flex tw-flex-row tw-justify-between tw-align-middle tw-border-t tw-border-dark-grey tw-py-2">
                                            <div class="tw-text-2xl tw-mt-1">{{ category }}</div>
                                            <v-icon>
                                                <template v-if="open">mdi-minus-circle</template>
                                                <template v-else>mdi-plus-circle</template>
                                            </v-icon>
                                        </div>

                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div
                                        v-for="(item, index) in items"
                                        :key="index"
                                        class="tw-pl-1"
                                    >
                                        {{ item.name }} : <a class="link" target="_blank" :href="getLink(item.link)">{{ item.link }}</a>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-row>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayoutSidebarNav from "@/Layouts/AppLayoutSidebarNav.vue"

export default {
    name: "ResourceIndex",
    layout: (h, page) => {
        return h(AppLayoutSidebarNav, [
            page
        ])
    },
    components: {
        //
    },
    props: {
        'maps': {
            type: Array,
            required: true,
            default: function () {
                return undefined
            }
        },
        'links_by_category': {
            type: Object,
            required: true,
            default: function () {
                return undefined
            }
        }
    },
    data: function () {
        return {
            expanded_links_panels: [],
        }
    },
    mounted: function () {
        //
    },
    methods: {
        getLink(unformatted_link) {
            if (unformatted_link.indexOf("http://") === 0 || unformatted_link.indexOf("https://") === 0) {
                return unformatted_link
            }
            let protocol = 'http://'
            return `${protocol}${unformatted_link}`
        },
    },
}
</script>
<style scoped>
ol li::marker {
    font-weight: 400;
}
li {
    font-weight: 300;
}
.link {
    color: #0000EE;
    text-decoration: underline;
    font-size: 0.8em !important;
}
.v-expansion-panel-header {
    padding: 0 !important;
    padding-left: 13px !important;
}
</style>
